import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {
            site: {
                title: 'MuslimTree.org'
            },
            app: {
                loading: 'Loading data...',
                error: 'Failed to load data. Please try again.',
                retry: 'Retry'
            },
            language: {
                switch: 'Switch language'
            },
            user: {
                profile: 'User profile'
            },
            search: 'Search Prophets, Sahabas, or Scholars',
            categories: {
                quran: 'Quran',
                hadith: 'Hadith',
                prophet: 'Prophet',
                sahabas: 'Sahabas',
                scholars: 'Scholars',
                sects: 'Sects',
                legalSchools: 'Legal Schools',
                timeline: 'Timeline'
            },
            features: {
                authenticSources: {
                    title: 'Authentic Sources',
                    description: 'Access verified and authentic Islamic sources for accurate information.'
                },
                interactiveLearning: {
                    title: 'Interactive Learning',
                    description: 'Engage with interactive visualizations and dynamic content.'
                },
                multilingualSupport: {
                    title: 'Multilingual Support',
                    description: 'Access content in multiple languages for a global audience.'
                }
            },
            footer: {
                description: 'Discover the rich history and knowledge of Islam through interactive visualizations and comprehensive data.',
                copyright: '© {{year}} MuslimTree. All rights reserved.',
                quickLinks: 'Quick Links',
                about: 'About Us',
                contact: 'Contact',
                privacy: 'Privacy Policy',
                connect: 'Connect'
            }
        }
    },
    ar: {
        translation: {
            site: {
                title: 'شجرة الإسلام'
            },
            app: {
                loading: 'جاري تحميل البيانات...',
                error: 'فشل في تحميل البيانات. يرجى المحاولة مرة أخرى.',
                retry: 'إعادة المحاولة'
            },
            language: {
                switch: 'تغيير اللغة'
            },
            user: {
                profile: 'الملف الشخصي'
            },
            search: 'ابحث عن الأنبياء أو الصحابة أو العلماء',
            categories: {
                quran: 'القرآن الكريم',
                hadith: 'الحديث النبوي',
                prophet: 'الأنبياء',
                sahabas: 'الصحابة',
                scholars: 'العلماء',
                sects: 'المذاهب',
                legalSchools: 'المدارس الفقهية',
                timeline: 'الجدول الزمني'
            },
            features: {
                authenticSources: {
                    title: 'مصادر موثوقة',
                    description: 'الوصول إلى مصادر إسلامية موثوقة ومصادق عليها للحصول على معلومات دقيقة.'
                },
                interactiveLearning: {
                    title: 'تعلم تفاعلي',
                    description: 'تفاعل مع التصورات التفاعلية والمحتوى الديناميكي.'
                },
                multilingualSupport: {
                    title: 'دعم متعدد اللغات',
                    description: 'الوصول إلى المحتوى بلغات متعددة لجمهور عالمي.'
                }
            },
            footer: {
                description: 'اكتشف التاريخ الغني ومعرفة الإسلام من خلال التصورات التفاعلية والبيانات الشاملة.',
                copyright: '© {{year}} شجرة الإسلام. جميع الحقوق محفوظة.',
                quickLinks: 'روابط سريعة',
                about: 'من نحن',
                contact: 'اتصل بنا',
                privacy: 'سياسة الخصوصية',
                connect: 'تواصل معنا'
            }
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n; 